module.exports = __webpack_public_path__ + "img/gsb17.171b19ca.png";